// 静态常亮配置


export default {
  // 网站标题
  title: '鲲鹏共享科技',
  // 网站描述
  description: '鲲鹏共享云',
  // 网站关键词
  keywords: '鲲鹏共享云',
  // 网站备案号（示例：粤ICP备00000000号-1）
  icp: '闽ICP备2021011916号-22A',
  // 备案查询链接
  icpUrl: 'https://beian.miit.gov.cn/',
  // 版权所有
  copyright: '2025. All right reserved.',
  // 安卓下载链接
  androidDownloadUrl: 'https://www.kunpenggx.com/KunpengAPP/KunPeng308.apk',
  // 苹果下载链接
  iosDownloadUrl: 'https://apps.apple.com/us/app/%E9%B2%B2%E9%B9%8F%E5%85%B1%E4%BA%AB%E7%A7%91%E6%8A%80/id6751181482',
  // 鸿蒙下载链接
  harmonyDownloadUrl: 'https://www.kunpenggx.com/KunpengAPP/KunPeng111.app',
}